/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/label-has-for */
import { Actions, Can, Subjects, useRole } from '@efexteam/permission-manager';
import Lending from '@pages/lending/components/Lending/Lending';
import { useEffect, useState } from 'react';
import 'react-datepicker/dist/react-datepicker.css';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import BulksPayablesTable from '../../components/payables/BulksPayablesTable';
import useBoolean from '../../hooks/useBoolean';
import OutletLayout from '../../layout/OutletLayout';
import {
  PayableTypeFilter,
  PayableTypes,
  TabPayables,
  TabsPayableFilter,
} from '../../services/client/types';
import {
  FORM_INITIAL_BULK_UPLOAD,
  IUploadBulksDocuments,
} from '../../services/documents/types';
import { selectProfileData } from '../profile/store/selectors';
import BulksPayments from './components/BulksPayments';
import PaymentsTable from './components/paymentsTable/PaymentTable';
import PaymentTabs, { ITabSelected } from './components/PaymentTabs';
import PaymentsHeader from './components/PaymentsHeader';

const Payables = () => {
  const { t } = useTranslation();
  const userProfile = useSelector(selectProfileData);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [bulksForm, setBulksForm] = useState<IUploadBulksDocuments>(
    FORM_INITIAL_BULK_UPLOAD
  );

  const [payableType, setPayableType] = useState<
    PayableTypeFilter | TabsPayableFilter
  >(PayableTypes.PROCCESS);
  const [bulkPayment, setBulkPayment] = useState(false);
  const [loadingPayments, setLoadingPayments] = useState(false);
  const [tabValidated, setTabValidated] = useState(false);

  const [reloadFiles, { setFalse: notReloadFiles, setTrue: doReloadFiles }] =
    useBoolean(false);

  const { isReadOnly } = useRole();

  const handleFilesBulksDocument = (files: FileList | undefined) => {
    if (!bulksForm) return;
    if (files && files.length) {
      setBulksForm({ ...bulksForm, bulksDocument: files[0] });
      return;
    }
    setBulksForm({ ...bulksForm, bulksDocument: undefined });
  };

  const setUrlParam = (type: string) => {
    navigate({
      search: `?tab=${type.toLowerCase()}`,
    });
  };

  const handleTabSelected = ({ tab, isBulkPayment }: ITabSelected) => {
    if (isBulkPayment) {
      setUrlParam('bulks');
      return;
    }
    setBulkPayment(isBulkPayment);
    setUrlParam(tab);
    setPayableType(tab);
  };

  const urlTabSelect = (type: TabPayables) => {
    if (searchParams.get('tab') === type.toLowerCase()) {
      setPayableType(type);
    }
  };

  const PAYMENTS_VIEW: Record<'bulks', React.ReactElement> = {
    bulks: (
      // eslint-disable-next-line react/jsx-no-useless-fragment
      <Can action={Actions.CREATE} subject={Subjects.BULK_PAYMENTS}>
        {userProfile?.canUserWithdraw ? (
          <>
            <BulksPayments
              handleFilesBulksDocument={handleFilesBulksDocument}
              handleUploadFile={doReloadFiles}
            />
            <BulksPayablesTable
              shouldReloadFiles={reloadFiles}
              filesReloaded={notReloadFiles}
            />
          </>
        ) : (
          <div />
        )}
      </Can>
    ),
  };

  useEffect(() => {
    if (bulkPayment) setBulkPayment(bulkPayment);
  }, [bulkPayment]);

  useEffect(() => {
    setTabValidated(false);
    if (searchParams.get('tab')) {
      const type =
        (searchParams.get('tab')?.toUpperCase() as TabPayables) ??
        TabPayables.PROCESSING;
      urlTabSelect(type);

      if (type === TabPayables.BULKS && userProfile?.isFullRegister) {
        setBulkPayment(true);
      } else if (type === TabPayables.BULKS && !isReadOnly) {
        setBulkPayment(true);
      } else {
        setBulkPayment(false);
      }
    }
    setTabValidated(true);
  }, [searchParams, isReadOnly]);

  if (!tabValidated) return null;

  return (
    <OutletLayout title={t('payables') || ''} fullWidth>
      <div>
        <PaymentTabs
          payableType={payableType}
          bulkPayment={bulkPayment}
          isLoadingPayments={loadingPayments}
          onTabSelected={handleTabSelected}
        />
        {!bulkPayment && payableType !== PayableTypes.LENDING ? (
          <PaymentsHeader />
        ) : null}
        {PAYMENTS_VIEW[searchParams.get('tab') as 'bulks'] ?? null}
        {payableType !== PayableTypes.LENDING &&
        payableType !== TabPayables.BULKS ? (
          <div>
            <PaymentsTable
              setIsLoadingPayments={setLoadingPayments}
              payableType={payableType as TabsPayableFilter}
            />
          </div>
        ) : null}
        {payableType === PayableTypes.LENDING ? <Lending /> : null}
      </div>
    </OutletLayout>
  );
};

export default Payables;
